const WPBlockCoverVideo = (domEl) => {

	const videoBlock = domEl.querySelector('.core-cover-video');
	const videoSrc = videoBlock.getAttribute('data-src');

	if(!videoSrc) {
		return;
	}

	// Append video and autoplay
	const videoEl = document.createElement('video');
	videoEl.src = videoSrc;
	videoEl.playsInline = true;
	videoEl.controls = false;
	videoEl.muted = true;
	videoEl.autoplay = true;
	videoEl.loop = true;

	videoBlock.appendChild(videoEl);
	videoBlock.classList.add('js-video-added');
};

export default WPBlockCoverVideo;